export const headerDropdowns = () => {
    const header = document.querySelector('.header');
    const menuItems = document.querySelectorAll('.header__small-menu .menu-item-has-children');
    const languageSwitchers = document.querySelectorAll('.header__lang');

    if (!header && !menuItems.length && !languageSwitchers.length) return;

    const toggleHeaderState = () => {
        if (!header) return;

        if (window.scrollY > 20) {
            header.classList.add('header--active');
        } else {
            header.classList.remove('header--active');
        }
    };

    toggleHeaderState();
    window.addEventListener('scroll', toggleHeaderState, { passive: true });

    const closeAll = () => {
        menuItems.forEach((menuItem) => {
            menuItem.classList.remove('menu-item-has-children--active');
        });

        languageSwitchers.forEach((languageSwitcher) => {
            languageSwitcher.classList.remove('header__lang--active');

            const toggle = languageSwitcher.querySelector('.header__lang-toggle');

            if (toggle) {
                toggle.setAttribute('aria-expanded', 'false');
            }
        });
    };

    const setCurrentMenuItems = () => {
        menuItems.forEach((menuItem) => {
            const isCurrent = menuItem.classList.contains('current-menu-parent')
                || menuItem.classList.contains('current-menu-ancestor')
                || menuItem.classList.contains('current_page_parent')
                || menuItem.classList.contains('current_page_ancestor');

            menuItem.classList.toggle('menu-item-has-children--current', isCurrent);
        });
    };

    setCurrentMenuItems();

    menuItems.forEach((item) => {
        item.addEventListener('click', (event) => {
            event.stopPropagation();

            const isActive = item.classList.contains('menu-item-has-children--active');

            menuItems.forEach((menuItem) => {
                menuItem.classList.remove('menu-item-has-children--active');
            });

            languageSwitchers.forEach((languageSwitcher) => {
                languageSwitcher.classList.remove('header__lang--active');

                const toggle = languageSwitcher.querySelector('.header__lang-toggle');

                if (toggle) {
                    toggle.setAttribute('aria-expanded', 'false');
                }
            });

            if (!isActive) {
                item.classList.add('menu-item-has-children--active');
            }
        });
    });

    languageSwitchers.forEach((languageSwitcher) => {
        const toggle = languageSwitcher.querySelector('.header__lang-toggle');

        if (!toggle) return;

        toggle.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();

            const isActive = languageSwitcher.classList.contains('header__lang--active');

            menuItems.forEach((menuItem) => {
                menuItem.classList.remove('menu-item-has-children--active');
            });

            languageSwitchers.forEach((otherSwitcher) => {
                if (otherSwitcher !== languageSwitcher) {
                    otherSwitcher.classList.remove('header__lang--active');
                    const otherToggle = otherSwitcher.querySelector('.header__lang-toggle');

                    if (otherToggle) {
                        otherToggle.setAttribute('aria-expanded', 'false');
                    }
                }
            });

            if (!isActive) {
                languageSwitcher.classList.add('header__lang--active');
                toggle.setAttribute('aria-expanded', 'true');
            } else {
                languageSwitcher.classList.remove('header__lang--active');
                toggle.setAttribute('aria-expanded', 'false');
            }
        });
    });

    document.addEventListener('click', () => {
        closeAll();
    });
};